import type { Dashboard } from '../../types'
import PowerBI from './PowerBI'
import Metabase, { MetabaseToken } from './Metabase'

function AnyDashboard({ children: { id, name } }: { children: Dashboard }) {

    if (PowerBI.isPowerBI(id)) {
        return <PowerBI id={id} />
    }

    if (Metabase.isMetabase(id)) {
        return <Metabase token={id as MetabaseToken} name={name} />
    }

    return <>Not valid dashboard {id}</>
}

export default AnyDashboard
